import { Module } from 'cerebral'
import eventRecieved from './chains/eventRecieved'

export default Module(({ name, path, controller }) => {
  return {
    signals: {
      eventRecieved
    }
  }
})



// WEBPACK FOOTER //
// ./src/modules/Socket/index.js